module.exports = __webpack_public_path__ + "static/media/H_Baayen.07423684.jpg";